import { Code, Section, SubTitle } from './Section';

const dimensions = [
  ['w-search-bar', '300 px'],
  ['h-search-bar', '52 px'],
  ['w-search-expanded', '620 px'],
  ['h-search-expanded', '480 px'],
  ['w-spotlight', '640 px'],
  ['max-w-spotlight', '100vw − 48 px'],
  ['max-h-spotlight', '70vh'],
  ['pt-spotlight-offset', '18vh'],
  ['w-notifications', '400 px'],
  ['max-w-rail-label / max-w-rail-detail', '180 / 160 px'],
  ['max-w-profile-label', '120 px'],
  ['max-w-chat-turn', '85%'],
] as const;

export function ShellTokensSection() {
  return (
    <Section
      id="shell-tokens"
      title="Значения оболочки"
      lead="Именованные значения прежних страниц. Размеры, цвета и тени сохранены; новые значения добавляются по правилам DESIGN.md §8."
    >
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="flex flex-col gap-4 rounded-lg border border-line bg-card p-5">
          <SubTitle>Размеры</SubTitle>
          <dl className="flex flex-col divide-y divide-line">
            {dimensions.map(([name, value]) => (
              <div key={name} className="flex flex-wrap items-center justify-between gap-3 py-2">
                <dt>
                  <Code>{name}</Code>
                </dt>
                <dd className="text-xs text-fg-muted">{value}</dd>
              </div>
            ))}
          </dl>
          <SubTitle>Текст</SubTitle>
          <p className="text-notification-body">Текст уведомления · 12,5 px</p>
          <p className="text-ai-suggestion">Подсказка помощника · 13,5 px</p>
          <p className="text-search-input">Ввод поиска · 15 px</p>
          <p className="text-ai-input">Ввод ИИ · 17 px</p>
        </div>
        <div className="flex flex-col gap-4 rounded-lg border border-line bg-card p-5">
          <SubTitle>Цвета и поверхности</SubTitle>
          <div className="flex flex-wrap gap-3">
            <span className="rounded-md service-enabled px-3 py-2 text-sm">Подключён</span>
            <span className="rounded-md service-available px-3 py-2 text-sm">Доступен</span>
          </div>
          <div className="rounded-md border notice-error px-3 py-2 text-sm">Ошибка</div>
          <div className="rounded-md border notice-success px-3 py-2 text-sm">Готово</div>
          <SubTitle>Тени</SubTitle>
          <div className="grid grid-cols-2 gap-6">
            <div className="rounded-lg bg-card p-4 shadow-search-expanded">
              <Code>shadow-search-expanded</Code>
            </div>
            <div className="rounded-lg bg-card p-4 shadow-notifications">
              <Code>shadow-notifications</Code>
            </div>
            <div className="rounded-lg bg-card p-4 shadow-market-card">
              <Code>shadow-market-card</Code>
            </div>
            <div className="rounded-lg bg-card p-4 shadow-spotlight">
              <Code>shadow-spotlight</Code>
            </div>
          </div>
          <p className="text-xs text-fg-muted">
            Переходы используют именованные рецепты transition-rail-* и transition-card-surface. Проверка
            ограждений: npm run test:design-rules.
          </p>
        </div>
      </div>
    </Section>
  );
}
